import {WhitelabelEntity} from "@portal-workspace/grow-shared-library";
import {Observable} from "rxjs";

export type WhitelabelSelectionValue  = WhitelabelEntity | null;

export type GetAllWhitelabelsFn = ()=>Observable<WhitelabelEntity[]>;
